<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Update Position Description</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text>
				<div class="pt-3 pb-2">
					<p class="font-weight-bold">Would you like to trigger a new approval workflow for these changes?</p>
					<p class="info-text">
						Triggering a new approval workflow will require the manager (or an admin) to re-approve the Position Description.
						<span v-if="requireEmployeeAcknowledgement"> The employee will also need to acknowledge the changes.</span>
						<span v-else> It will become live immediately after approval; employee acknowledgement is not required.</span>
					</p>
				</div>
				<v-switch v-model="result" label="Yes, trigger new approval workflow"></v-switch>

				<v-alert :value="!result" color="warning" icon="warning" class="text-xs-left" outline>
					<span v-if="coreItemsUpdated">It is recommended that you trigger a new approval workflow so that the employee is made aware of these changes. If not, the employee will not be notified of the changes made to this document.</span>
					<span v-else>The employee will not be notified of the changes made to this document.</span>
				</v-alert>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn flat @click="onCancel"> Cancel </v-btn>

				<v-btn color="primary" flat @click="onConfirm"> Save Changes </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			currentStatus: {
				type: Number,
				required: true
			},
			coreItemsUpdated: {
				type: Boolean,
				required: true
			},
			requireEmployeeAcknowledgement: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				result: true
			};
		},
		methods: {
			onConfirm() {
				this.$emit('onConfirm', this.result);
			},
			onCancel() {
				this.$emit('onCancel');
			}
		}
	};
</script>

<style scoped>
	.info-text {
		color: rgba(0, 0, 0, 0.54);
	}
</style>
